import React from 'react';
import { assertIsDashboardPluginProps } from '@deephaven/dashboard';
import Linker from "./linker/Linker.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function LinkerPlugin(props) {
  assertIsDashboardPluginProps(props);
  var id = props.id,
    layout = props.layout,
    panelManager = props.panelManager;
  return /*#__PURE__*/_jsx(Linker, {
    layout: layout,
    localDashboardId: id,
    panelManager: panelManager
  });
}
export default LinkerPlugin;
//# sourceMappingURL=LinkerPlugin.js.map